import React from 'react';
import StatusBanner from '../../common/StatusBanner';
import VideoVisitConfirmationStatus from './VideoVisitConfirmationStatus';
import Spinner from "../../common/spinner";
import VideoVisitTips from "../../dashboard/appointment/VideoVisitTips";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

const bannerMsg = "Thanks, you're all set! We look forward to seeing you.", subBannerMsg = "You will receive an email confirming your appointment.",
      errorMsg = "We were unable to schedule your appointment";


class VideoVisitConfirmation extends React.Component {
    constructor() {
        super();
        this.state = {
            showVideoVisitTipsModal: false
        }
    }
    onRetry = () => {
        this.props.retryVideoVisitRequest();
    }

    toggleVideoVisitTipsModal = () => {
        let activityCodeForModal = 'MBHWeb.UI.VideoVisitConfirmation.VideoVisitTips.Open';
        if (this.state.showVideoVisitTipsModal) {
            activityCodeForModal = 'MBHWeb.UI.VideoVisitConfirmation.VideoVisitTips.Close';
        }
        logUI(activityCodeForModal, new Date(), Tools.getURLPath());
        this.setState({ showVideoVisitTipsModal: !this.state.showVideoVisitTipsModal });
    }

    render() {
        const { isWaiting, isSuccess, isError } = this.props.videoVisit;
        const { technicalHelpDeskNumber, technicalHelpDeskHours, timezone, showTimeZoneMessage } = this.props;
        const { showVideoVisitTipsModal } = this.state;
        return (
            <div className="schedule-confirmation-container" style={this.props.style}>
                {isWaiting ?
                    <Spinner />
                    :
                    <div className="row">
                        <div className="col-12">
                            <StatusBanner
                                bannerMsg={!isSuccess ? errorMsg : bannerMsg}
                                subBannerMsg={!isSuccess ? "" : subBannerMsg}
                                failedStatus={isError}
                            >
                                {isError &&
                                    <span>
                                    Please <a href="#" onClick={() => this.onRetry()}>try again</a>. For technical issues, call the MyBSWHealth technical help desk{technicalHelpDeskHours && <>{` `}{technicalHelpDeskHours}</>}{technicalHelpDeskNumber && <span> at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a></span>}.
                                    </span>
                                }
                            </StatusBanner>
                        </div>
                        { (isSuccess || isError) &&
                            <div className="col-12">
                                <div className={`row ${isError ? 'schedule-failure' : ''}`}>
                                    <div className="col-12 confirm-container maxWidth-content">
                                    <VideoVisitConfirmationStatus videoVisitConfirmationData={this.props.videoVisitConfirmationData} videoVisitCSN={this.props.videoVisit.response ? this.props.videoVisit.response.csn : ""} failedStatus={isError} timezone={timezone} showTimeZoneMessage={showTimeZoneMessage} />
                                    </div>
                                </div>
                            </div>
                        }
                        {isSuccess &&
                            <div className="col-12 maxWidth-content">
                                <div className="tips-banner-container">
                                    <div className="details-icon-prepend">
                                        <div className="icon-col">
                                            <div className="svg-tips" />
                                        </div>
                                        <div className="details-col">
                                            <div className="tips-text">Be ready! See our helpful tips for a more successful Video Visit.</div>
                                            <button className="btn text-btn" onClick={this.toggleVideoVisitTipsModal}>VIEW TIPS</button>
                                        </div>
                                    </div>
                                </div>
                                {showVideoVisitTipsModal && <VideoVisitTips showVideoVisitTipsModal={showVideoVisitTipsModal} toggleVideoVisitTipsModal={this.toggleVideoVisitTipsModal} />}
                            </div>
                        }
                        {(isSuccess && window.serverData.data.enableQualtricsSurvyVideoVisit) && <div id="bsw_qtx"/>}
                    </div>
                }
            </div>
        );
    }
}

export default VideoVisitConfirmation;